import type { PaymentInterval } from '@/types/purchase/PaymentInterval'

export const getPaymentCount = (
  paymentInterval: PaymentInterval | undefined
): number => {
  let paymentCount: number
  switch (paymentInterval) {
    case 'monthly':
      paymentCount = 1
      break
    case 'quarterly':
      paymentCount = 3
      break
    case 'half-annually':
      paymentCount = 6
      break
    case 'annually':
      paymentCount = 12
      break
    default:
      paymentCount = 1
  }
  return paymentCount
}
